import { Injectable, Inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { switchMap, map, withLatestFrom, catchError, mergeMap } from 'rxjs/operators';
import { IAppState } from '../state/app.state';
import { Observable, of } from 'rxjs';
import { CompanyService } from '../../Services/Company/company.service';
import { ECompanyActions, CreateCompany, CreateCompanySuccess,
    CreateCompanyError, GetAllCompanies, GetAllCompaniesSuccess,
    GetAllCompaniesErrorMessage, EditCompany, EditCompanySuccess,
    EditCompanyError, RenewLicenseDate, RenewLicenseDateSuccess,
    RenewLicenseDateError, GiveExtensionDate, GiveExtensionDateSuccess,
    GiveExtensionDateError, ConvertToActive, ConvertToActiveSuccess, ConvertToActiveError, GetCompanyById, InactivateCmpy, GetCompanyLicense, ActivateCmpy,GetUsersCount,GetAllUsers,
    GetUsersCountSuccess,GetUsersCountError,GetAllUsersSuccess,GetAllUsersError,BulkInactivate,BulkActivate,BulkDelete } from '../actions/company.action';
import { EditCompanyService } from '../../Services/EditCompany/edit-company.service';



@Injectable()
export class CompanyEffects {

    createcompany$ = createEffect(() => this.actions$.pipe(
        ofType<CreateCompany>(ECompanyActions.CreateCompany),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.companyservice.addCompany(payload).pipe(
                map((createsuccess: any) => {
                    return new CreateCompanySuccess(createsuccess, this.store);
                }),
                catchError((err) => of(new CreateCompanyError(err, this.store)))
            );
        })));

    getcompanydetails$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllCompanies>(ECompanyActions.GetAllCompanies),
        map(action => action),
        switchMap((payload: any) => {
            return this.companyservice.getAllCompanies(payload).pipe(
                map((companydetails: any) => {
                    return new GetAllCompaniesSuccess(companydetails);
                }),
                catchError((err) => of(new GetAllCompaniesErrorMessage(err)))
            );
        })));

    editCompany$ = createEffect(() => this.actions$.pipe(
        ofType<EditCompany>(ECompanyActions.EditCompany),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.editCompanyService.editCompany(payload).pipe(
                map((editSuccess: any) => {
                    return new EditCompanySuccess(editSuccess);
                }),
                catchError((err) => of(new EditCompanyError(err)))
            );
        })));

    renewLicense$ = createEffect(() => this.actions$.pipe(
        ofType<RenewLicenseDate>(ECompanyActions.RenewLicenseDate),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.editCompanyService.renewLicense(payload).pipe(
                map((renewSuccess: any) => {
                    return new RenewLicenseDateSuccess(renewSuccess);
                }),
                catchError((err) => of(new RenewLicenseDateError(err)))
            );
        })));

        convertToActive$ = createEffect(() => this.actions$.pipe(
            ofType<ConvertToActive>(ECompanyActions.ConvertToActive),
            map(action => action.payload),
            switchMap((payload: any) => {
                return this.editCompanyService.convertToActive(payload).pipe(
                    map((success: any) => new ConvertToActiveSuccess(success)),
                    catchError((err) => of(new ConvertToActiveError(err)))
                );
            })
        ));

    giveExtension$ = createEffect(() => this.actions$.pipe(
            ofType<GiveExtensionDate>(ECompanyActions.GiveExtensionDate),
            map(action => action.payload),
            switchMap((payload : any) => {
                return this.editCompanyService.giveExtension(payload).pipe(
                    map((extensionSuccess: any) => {
                        return new GiveExtensionDateSuccess(extensionSuccess);
                    }),
                    catchError((err) => of(new GiveExtensionDateError(err)))
                );
            })));

          inActivateCmpy$ = createEffect(() => this.actions$.pipe(
                 ofType<InactivateCmpy>(ECompanyActions.InactivateCmpy),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.editCompanyService.inActivateCompany(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Get Inactivate Company Success', payload: result, from: 'Inactivatecmpy' })),
                   catchError((err) => of({ type: '[Company] Get Inactivate Company Error', payload:err, from: 'Inactivatecmpy' }))
                 )
               )
             ));


             activateCmpy$ = createEffect(() => this.actions$.pipe(
                    ofType<ActivateCmpy>(ECompanyActions.ActivateCmpy),
                    map(action => action.payload),
                    mergeMap((payload : any) => this.editCompanyService.activateCompany(payload)
                    .pipe(map((result: any) => ({ type: '[Company] Get Activate Company Success', payload: result, from: 'Activatecmpy' })),
                      catchError((err) => of({ type: '[Company] Get Activate Company Error', payload:err, from: 'Activatecmpy' }))
                    )
                  )
                ));

           getCompanyById$ = createEffect(() => this.actions$.pipe(
                ofType<GetCompanyById>(ECompanyActions.GetCompanyById),
                map(action => action.payload),
                mergeMap((payload : any) => this.editCompanyService.getCompanyById(payload)
                .pipe(map((result: any) => ({ type: '[Company] Get Company By Id Success', payload: result, from: 'getCompanyById' })),
                  catchError((err) => of({ type: '[Company] Get Company By Id Error', payload:err, from: 'getCompanyById' }))
                )
              )
            ));

            getCompanyLicense$ = createEffect(() => this.actions$.pipe(
                 ofType<GetCompanyLicense>(ECompanyActions.GetCompanyLicense),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.editCompanyService.getCompanyLicense(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Get Company License Success', payload: result, from: 'getCompanyLicense' })),
                   catchError((err) => of({ type: '[Company] Get Company License Error', payload:err, from: 'getCompanyLicense' }))
                 )
               )
             ));

            getUsersCount$ = createEffect(() => this.actions$.pipe(
                 ofType<GetUsersCount>(ECompanyActions.GetUsersCount),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.editCompanyService.getUsersCount(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Get Users Count Success', payload: result, from: 'getUsersCountSuccess' })),
                   catchError((err) => of({ type: '[Company] Get Users Count Error', payload:err, from: 'getUsersCountSuccess' }))
                 )
               )
             ));

            getAllUsers$ = createEffect(() => this.actions$.pipe(
                 ofType<GetAllUsers>(ECompanyActions.GetAllUsers),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.editCompanyService.getAllUsers(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Get All Users Success', payload: result, from: 'getAllUsersSuccess' })),
                   catchError((err) => of({ type: '[Company] Get All Users Error', payload:err, from: 'getAllUsersSuccess' }))
                 )
               )
             ));

            bulkInactivate$ = createEffect(() => this.actions$.pipe(
                 ofType<BulkInactivate>(ECompanyActions.BulkInactivate),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.companyservice.bulkInactivate(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Bulk Inactivate Success', payload: result, from: 'bulkInactivate' })),
                   catchError((err) => of({ type: '[Company] Bulk Inactivate Error', payload:err, from: 'bulkInactivate' }))
                 )
               )
             ));

            bulkActivate$ = createEffect(() => this.actions$.pipe(
                 ofType<BulkActivate>(ECompanyActions.BulkActivate),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.companyservice.bulkActivate(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Bulk Activate Success', payload: result, from: 'bulkActivate' })),
                   catchError((err) => of({ type: '[Company] Bulk Activate Error', payload:err, from: 'bulkActivate' }))
                 )
               )
             ));

            bulkDelete$ = createEffect(() => this.actions$.pipe(
                 ofType<BulkDelete>(ECompanyActions.BulkDelete),
                 map(action => action.payload),
                 mergeMap((payload : any) => this.companyservice.bulkDelete(payload)
                 .pipe(map((result: any) => ({ type: '[Company] Bulk Delete Success', payload: result, from: 'bulkDelete' })),
                   catchError((err) => of({ type: '[Company] Bulk Delete Error', payload:err, from: 'bulkDelete' }))
                 )
               )
             ));

    constructor(
        private actions$: Actions,
        private store: Store<IAppState>,
        private companyservice: CompanyService,
        private editCompanyService: EditCompanyService
    ) { }

}
